import { isPhoneInLandscape } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      header: {
        borderBottom: `1px solid ${tokens.borderColorSubtle}`,
        padding: '20px 24px',

        [isPhoneInLandscape]: {
          padding: '10px',
        },
      },
    },
  } as const
}
